export const HIGH_FUND_LOGGED_OUT_QUOTE_THRESHOLD = 500000;

export function parsePensionFundAmount(value: unknown): number {
  const parsed = parseFloat(String(value ?? "").replace(/[^0-9.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function calculatePurchaseFundAmount(
  pensionFund: unknown,
  taxFreeCashTypeID: unknown
): number {
  const fundAmount = parsePensionFundAmount(pensionFund);

  // if no tax free cash taken assume they will take max so use 75% of fund amount
  if (String(taxFreeCashTypeID) === "5907") {
    return fundAmount * 0.75;
  }

  return fundAmount;
}

export function isHighFundLoggedOutQuoteAmount(
  pensionFund: unknown,
  taxFreeCashTypeID: unknown
): boolean {
  return (
    calculatePurchaseFundAmount(pensionFund, taxFreeCashTypeID) >
    HIGH_FUND_LOGGED_OUT_QUOTE_THRESHOLD
  );
}
